module.exports = __webpack_public_path__ + "static/media/xanil.2a7ea735.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/phythophtora_palmivora/preventiva/xanil.png
// module id = 2299
// module chunks = 3